module.exports = __webpack_public_path__ + "img/phone_2.3d57d28e.png";